<template>

  <section class="cid-qTkA127IK8 mbr-fullscreen mbr-parallax-background" id="header2-1">
    <div class="mbr-overlay" style="opacity: 0.5; background-color: rgb(118, 118, 118);"></div>

    <div class="container align-center">
      <div class="row justify-content-md-center">
        <div class="mbr-white col-md-9">
          <h1 class="mbr-section-title mbr-bold pb-3 mbr-fonts-style display-1">
            欢迎访问<a href="/">Go4Pro.org</a>
          </h1>
          <h3 class="mbr-section-subtitle align-center mbr-light pb-3 mbr-fonts-style display-2">
            一个精选编程技术文章站点
          </h3>
          <p class="mbr-text pb-3 mbr-fonts-style display-5">
            <a href="/">Go4Pro.org</a>成立于2009年，汇集BT群中<span class="text-primary">{{summary.aac}}</span>位好朋友历年的技术文章。主题涵盖PHP，Python，CSS，JavaScript，Dart，Flutter，数据库等<span class="text-primary">{{summary.cc}}</span>个领域。<br/>
            截止{{today}}，本站点已经收录文章<span class="text-primary">{{summary.ac}}</span>篇，保持着每年<span class="text-primary">{{article_per_year}}</span>篇的高产数量，文章总字数为<span class="text-primary">{{Math.round(summary.wc/1000)}}</span>千字，浏览次数达<span class="text-primary">{{summary.vc}}</span>次。
          </p>
          <div class="mbr-section-btn">
            <router-link :to="{name: 'landingArticles'}" class="btn btn-md btn-secondary display-4">进入站点</router-link>
          </div>
        </div>
      </div>
    </div>
    
  </section>
  </template>

  <script>
  export default {
    name: "Index",
    data: function() {
      return {
        summary: [],
        article_per_year: 0,
        today: ''
      }
    },
    methods: {
      getArticleCount() {
        var uri="http://api.go4pro.org/go4pro/article/summary";
        fetch(uri)
          .then(res => {
            return res.json();
          })
          .then(json => {
            this.summary=json[0];
            
            this.article_per_year=Math.round(this.summary.ac/(new Date().getFullYear()-2009+1));
          })
      }
    },
    created: function() {
      this.getArticleCount();
      var tmp=new Date();
      this.today=tmp.getFullYear()+"年"+(tmp.getMonth()+1)+"月"+tmp.getDate()+"日";
    }



  }
  </script>